import { computed, defineComponent, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { ProvinceTaskAction, ProvinceTaskGetter } from '@/store/provinceTask/provinceTask.module';
import { ProvinceTask } from '@/store/provinceTask/provinceTask.model';
import ProvinceTaskDetailCompoent from '@/components/provinceTaskDetail/ProvinceTaskDetail.vue';

export default defineComponent({
  name: 'ProvinceTaskDetailPage',
  components: {
    ProvinceTaskDetailCompoent
  },
  setup: () => {
    const store = useStore();
    const route = useRoute();
    const provinceTaskId = computed<number>(() => parseInt(route.params.provincetaskId as string));
    const provinceTask = computed<ProvinceTask | undefined>(() => store.getters[ProvinceTaskGetter.BY_ID](provinceTaskId.value));
    const provinceName = computed(() => (provinceTask.value?.province.name === 'กรุงเทพมหานคร')
      ? provinceTask.value?.province.name
      : `จังหวัด${provinceTask.value?.province.name}`);
    const icon = computed(() => (provinceTask.value?.provinceTaskType.id !== 1)
      ? (provinceTask.value?.provinceTaskType.id !== 2)
        ? (provinceTask.value?.provinceTaskType.id !== 3)
          ? (provinceTask.value?.provinceTaskType.id !== 4)
            ? 'fa-universal-access'
            : 'fa-street-view'
          : 'fa-thumbs-up'
        : 'fa-asterisk'
      : 'fa-tags');
    const subtitle = computed(() => (provinceTask.value?.provinceTaskType.id !== 1)
      ? (provinceTask.value?.provinceTaskType.id !== 2)
        ? (provinceTask.value?.provinceTaskType.id !== 3)
          ? (provinceTask.value?.provinceTaskType.id !== 4)
            ? 'การแก้ไขปัญหาของศูนย์ดำรงธรรมในพื้นที่'
            : 'เขตเศรษฐกิจพิเศษ'
          : 'มาตรการกระตุ้นเศรษฐกิจ ในพื้นที่'
        : 'โครงการสำคัญของจังหวัด'
      : 'โครงการตามยุทธศาตร์จังหวัดและกลุ่มจังหวัด');
    const isLoading = computed(() => store.getters[ProvinceTaskGetter.STATUS] === 'init' || store.getters[ProvinceTaskGetter.STATUS] === 'loading');

    onMounted(() => {
      store.dispatch(ProvinceTaskAction.FIND, { id: provinceTaskId.value });
    });

    return {
      provinceTask,
      provinceName,
      icon,
      subtitle,
      isLoading,
    };
  },
});
